module.exports = __webpack_public_path__ + "static/media/dadhi.78cbce9c.webp";